<template>
  <div class="tenant-expose">
    <Card :bordered="false">
      <Row>
        <Col :xs="24" :sm="24" :md="6" :lg="6">
        <Card :bordered="false">
          <div slot="title">
            <Row>
              <Col :xs="24" :sm="24" :md="8" :lg="8">
              <Divider orientation="left">{{ langMap.tenantList[lang] }}</Divider>
              </Col>
              <Col :xs="24" :sm="24" :md="16" :lg="16">
              <Form :label-width="80">
                <div class="des-cardTittle-box">
                  <FormItem :label="langMap.keyword[lang]" class="leftFlex">
                    <Input v-model.trim="searchName" :placeholder="langMap.keyword[lang]" />
                  </FormItem>
                  <Button type="info" style="margin-left:20px;" @click="searchTenantData">
                    {{ langMap.search[lang] }}
                  </Button>
                </div>
              </Form>
              </Col>
            </Row>
          </div>

          <Table @on-row-click="onRowClick" :height="height" :loading="tenantTableLoading" border
            :columns="tenantColumns" :data="tenantList">
          </Table>

          <div style="text-align:center;padding-top:10px;" v-if="tenantList.length > 0">
            <Page :current="tenantIndex" :total="tenantTotal" :page-size="15" @on-change="goTenantPage">
            </Page>
          </div>
        </Card>
        </Col>

        <Col :xs="24" :sm="24" :md="18" :lg="18">
        <Card :bordered="false">
          <div slot="title">
            <Row>
              <Col :xs="24" :sm="24" :md="20" :lg="20">
              <Divider orientation="left">{{ title }}</Divider>
              </Col>
              <Col :xs="24" :sm="24" :md="4" :lg="4">
              <Form :label-width="80">
                <div class="des-cardTittle-box">
                  <Button type="primary" style="margin-left:20px;" @click="openAddModal">
                    {{ langMap.add[lang] }}
                  </Button>
                </div>
              </Form>
              </Col>
            </Row>
          </div>

          <Table :height="height" :loading="exposeTableLoading" border :columns="exposeColumns" :data="exposeList">
          </Table>
        </Card>
        </Col>
      </Row>
    </Card>

    <!-- 新增/编辑三方账户模态框 -->
    <Modal v-model="exposeModal" :title="modalTitle" @on-ok="saveExpose" @on-cancel="cancelExpose">
      <Form ref="exposeForm" :model="exposeForm" :rules="formRules" :label-width="100">
        <FormItem :label="langMap.exposeName[lang]" prop="name">
          <Input v-model="exposeForm.name" :placeholder="langMap.exposeName[lang]" />
        </FormItem>
        <FormItem :label="langMap.exposeAccount[lang]" prop="code">
          <Input v-model="exposeForm.code" :placeholder="langMap.exposeAccount[lang]" />
        </FormItem>
        <FormItem :label="langMap.exposePwd[lang]" prop="password">
          <Input v-model="exposeForm.password" :placeholder="langMap.exposePwd[lang]" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import api from "@/api";
import langMap from '@/utils/language';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      langMap: langMap,
      height: document.documentElement.clientHeight - 300,

      // 租户列表相关
      searchName: "",
      tenantIndex: 1,
      tenantTotal: 0,
      tenantList: [],
      tenantTableLoading: false,
      selectedTenant: {},

      // 三方账户列表相关  
      title: "",
      exposeList: [],
      exposeTableLoading: false,

      // 新增/编辑表单
      exposeModal: false,
      modalTitle: "",
      exposeForm: {
        tenantId: "",
        name: "",
        code: "",
        password: ""
      },
    }
  },

  computed: {
    ...mapState({
      lang: state => state.app.language
    }),

    tenantColumns() {
      return [
        {
          title: this.langMap.tenantCode[this.lang],
          key: "id"
        },
        {
          title: this.langMap.tenantName[this.lang],
          key: "name"
        }
      ]
    },

    exposeColumns() {
      return [
        {
          title: this.langMap.exposeName[this.lang],
          key: "name"
        },
        {
          title: this.langMap.exposeAccount[this.lang],
          key: "code"
        },
        {
          title: this.langMap.exposePwd[this.lang],
          key: "password"
        },
        {
          title: this.langMap.operation[this.lang],
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: "text"
                },
                style: {
                  padding: "1px",
                  color: "#2d8cf0"
                },
                on: {
                  click: () => {
                    this.deleteExpose(params.row)
                  }
                }
              }, this.langMap.delete[this.lang])
            ])
          }
        }
      ]
    },
    formRules() {
      return {
        code: [
          { required: true, message: this.langMap.exposeNotEmpty[this.lang], trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/[\u4e00-\u9fa5]/.test(value)) {
                callback(new Error(this.langMap.chineseNotAllowed[this.lang]));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        name: [{ required: true, message: this.langMap.exposeNameNotEmpty[this.lang], trigger: 'blur' }],
        password: [{ required: true, message: this.langMap.exposePwdNotEmpty[this.lang], trigger: 'blur' }]
      }
    }
  },

  methods: {
    // 租户列表相关方法
    searchTenantData() {
      this.tenantIndex = 1
      this.getTenantList()
    },

    getTenantList() {
      this.tenantTableLoading = true
      api.getData(`system-server/tenant/page?index=${this.tenantIndex}&name=${this.searchName}`, this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.tenantTotal = res.data.total
          this.tenantList = res.data.rows
          if (res.data.total > 0) {
            this.selectedTenant = this.tenantList[0]
            console.log(this.selectedTenant)
            console.log(this.tenantList)
            console.log(111)
            this.getExposeList()
            console.log(222)
          }
        }
        console.log(333)
        this.tenantTableLoading = false
        console.log(444)
      });
    },

    goTenantPage(index) {
      this.tenantIndex = index
      this.getTenantList()
    },

    onRowClick(row) {
      this.selectedTenant = row
      this.getExposeList()
    },

    // 三方账户相关方法
    getExposeList() {
      console.log(this.selectedTenant)
      if (!this.selectedTenant) return

      this.title = `${this.selectedTenant.name}${this.langMap.exposeListForTenant[this.lang]}`
      this.exposeTableLoading = true

      api.getData(`system-server/tenant/expose/list/${this.selectedTenant.id}`, this).then(res => {
        if (res.state === 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          })
        } else {
          this.exposeList = res.data || []
        }
        this.exposeTableLoading = false
      })
    },

    openAddModal() {
      if (!this.selectedTenant) {
        this.$Notice.warning({
          title: this.langMap.tip[this.lang],
          desc: this.langMap.selectTenantFirst[this.lang]
        })
        return
      }

      this.$refs.exposeForm && this.$refs.exposeForm.resetFields()
      this.exposeForm = {
        tenantId: this.selectedTenant.id,
        name: "",
        code: ""
      }
      this.modalTitle = this.langMap.addExpose[this.lang]
      this.exposeModal = true
    },

    saveExpose() {
      this.$refs.exposeForm.validate(valid => {
        if (valid) {
          this.$Spin.show()
          api.postData('system-server/tenant/expose/save', this.exposeForm, this).then(res => {
            if (res.state === 0) {
              this.$Notice.error({
                title: this.langMap.tip[this.lang],
                desc: res.msg
              })
            } else {
              this.$Notice.success({
                title: this.langMap.tip[this.lang],
                desc: this.langMap.saveSuccess[this.lang]
              })
              this.exposeModal = false
              this.getExposeList()
            }
            this.$Spin.hide()
          })
        }
      })
    },

    cancelExpose() {
      this.exposeModal = false
    },

    deleteExpose(row) {
      this.$Modal.confirm({
        title: this.langMap.tip[this.lang],
        content: this.langMap.confirmDelete[this.lang],
        onOk: () => {
          this.$Spin.show()
          api.getData(`system-server/tenant/expose/delete?id=${row.id}`, this).then(res => {
            if (res.state === 0) {
              this.$Notice.error({
                title: this.langMap.tip[this.lang],
                desc: res.msg
              })
            } else {
              this.$Notice.success({
                title: this.langMap.tip[this.lang],
                desc: this.langMap.deleteSuccess[this.lang]
              })
              this.getExposeList()
            }
            this.$Spin.hide()
          })
        }
      })
    }
  },

  created() {
    this.getTenantList()
  }
}
</script>

<style lang="less">
.tenant-expose {
  .des-cardTittle-box {
    display: flex;
    align-items: center;
  }

  .leftFlex {
    margin-right: 10px;
  }
}
</style>